import React, { useContext, useEffect, useMemo, useState } from "react";

import
{
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
  GridAlignment,
} from "@mui/x-data-grid-pro";
import
{
  AtsStckItemEdge,
  AtsStckItemOrderField,
  filterDataType,
  GetItemsResult,
  GetItemsVars,
  ItemQueryType,
} from "../../masters/items/queries/types";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import NoData from "../../../../../images/NoData.svg";

import { EMPTY_STRING, FETCH_MORE_DATA, debouncedDelay } from "../../../../../utils/constants";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { useLazyQuery } from "@apollo/client";

import { GetItems } from "../../masters/items/queries/queries";

import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import useLabels from "../../../../../customHooks/useLabels";
import
{
  getModifiedScrollHeight,
  handleMUISelectEvent,
} from "../../../../../utils/UtilFunctions";
import { Button } from "../../../../../stories/Button/Button";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../utils/types";
import EyeWhite from "../../../../../images/EyeWhite.svg";
import Input from "../../../../../stories/Input/Input";
import ItemGroupSelect from "../../../../../customComponents/ItemGroupSelect";
import ItemCategorySelect from "../../../../../customComponents/ItemCategorySelect";
import UoMSelect from "../../../../../customComponents/UoMSelect";
import { useNavigate } from "react-router-dom";

import { MapsContext } from "../../maps/context/context";

import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { useDebounce } from "../../../../../customHooks/useDebounce";
const VendorWiseItemsList = () =>
{

  const navigate = useNavigate();
  const { state, dispatch } = useContext( MapsContext );
  const [ searchData, setSearchData ] = useState( "" );
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const { Items } = useAssetTableJson();
  const { customer_id, company_id, supplier_id } = useUrlParams();
  const [ hasNextPage, setHasNextPage ] = useState<boolean>( true );
  const [ endCursor, setEndCursor ] = useState<string | null>( null );
  const [ items, setItems ] = useState<AtsStckItemEdge[]>( [] );

  const { user_details } = useLoggedInUserDetails();

  const [ filterData, setFilterData ] = useState<filterDataType>( {
    ItemGroupId: 0,
    ItemCategoryId: 0,
    UoMId: 0,
  } );
  const [ GetStockItems, { data, loading, fetchMore } ] = useLazyQuery<
    GetItemsResult,
    GetItemsVars
  >( GetItems );



  useEffect( () =>
  {
    if ( customer_id )
    {
      GetStockItems( {
        variables: {
          after: null,
          customerID: customer_id ? customer_id : 0,
          companyID: company_id
            ? company_id
            : state.company
              ? state.company.node.id
              : 0,
          first: null,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsStckItemOrderField.DESC,
          },

          name: debouncedSearch,
          hsnCode: EMPTY_STRING,
          input: {
            query_type: ItemQueryType.ITEMS_ASSOIC_LDGR,
            stckCategoryID: filterData.ItemCategoryId
              ? filterData.ItemCategoryId
              : 0,
            stckGroupID: filterData.ItemGroupId
              ? filterData.ItemGroupId
              : 0,
            stckManufacturerID: 0,
            stckUomID: filterData.UoMId ? filterData.UoMId : 0,
            stckSubCategoryID: 0,
            ldgrID: supplier_id ? supplier_id : 0,
            subsidiaryID: 0,
            isComponent: undefined,
            empID: user_details.id
          },
        },
      } );
    }
  }, [
    customer_id,
    company_id,
    GetStockItems,
    debouncedSearch,
    filterData,
    state.company,
    supplier_id,
    state.itemId,
    user_details.id,
  ] );

  const dynamicHeaders: TableHeaderProps[] = Items.List.filter(
    ( header ) => header.field !== "ob" && header.field !== "model"
  ).map( ( header ) => ( {
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    cellClassName: header.cellClassName,
    renderCell: ( params ) =>
    {
      if ( header.field === "actions" )
      {
        return (
          <>
            <button
              className="maps-comp-details__view"
              onClick={() =>
              {
                // dispatch({
                //   type: mapsPayloadType.ITEM_ID,
                //   payload: {
                //     itemId: params.row.itemId ? params.row.itemId : 0,
                //     // itmDesc: params.row.description
                //   },
                // });
                navigate(
                  `/${ customer_id }/company/${ company_id }/reports/vendorwise/${ params.row.itemId }/itemdetails`
                );
              }}
            >
              View Details
              <img src={EyeWhite} alt="" />
            </button>
          </>
        );
      }

      return params.value;
    },
  } ) );

  const columns: GridColDef[] = [ ...dynamicHeaders ];

  const rows: GridValidRowModel[] = useMemo( () =>
  {
    return items.map( ( { node: data }, index ) =>
    {
      return {
        id: index + 1,
        code: data.code,
        description: data.desc,
        group: data.groupDetails.groupName,
        category: data.categoryDetails.categoryName,
        sub_category: data.subCategoryDetails.subCategoryName,
        model: data.prodModel,
        total_asset: data.ldgr_count,
        uom: data.uomDetails.uomDesc,
        itemId: data.id,
      };
    } );
  }, [ items ] );

  useEffect( () =>
  {
    if ( data && !loading )
    {
      const newData = data.GetItems.edges;

      if ( endCursor )
      {
        const updatedNewData = newData.map( ( newCompany ) =>
        {
          const filteredStudent = items.find(
            ( sub ) => sub.node.id === newCompany.node.id
          );
          if ( filteredStudent )
          {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        } );
        setItems( updatedNewData );
      } else
      {
        setItems( newData );
      }
      setEndCursor( data.GetItems.pageInfo.endCursor );
    } // eslint-disable-next-line
  }, [ data, loading ] );
  useEffect( () =>
  {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[ 0 ] as Element;
    const handleScroll = ( e: Event ) =>
    {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if ( scrollTop + clientHeight >= getModifiedScrollHeight( scrollHeight ) )
      {
        if ( hasNextPage && !loading )
        {
          fetchMore( {
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: ( prevResult, { fetchMoreResult } ) =>
            {
              if ( !fetchMoreResult ) return prevResult;

              const newEdges = fetchMoreResult.GetItems.edges;
              const pageInfo = fetchMoreResult.GetItems.pageInfo;
              setEndCursor( pageInfo.endCursor );
              setHasNextPage( pageInfo.hasNextPage );

              const duplicateCheck = prevResult.GetItems.edges.filter(
                ( { node: { id } } ) =>
                  newEdges.findIndex(
                    ( { node: { id: newId } } ) => newId === id
                  ) !== -1
              );

              if ( duplicateCheck.length > 0 ) return prevResult;

              return {
                GetItems: {
                  edges: [ ...items, ...newEdges ],
                  pageInfo,
                  totalCount: data ? data.GetItems.totalCount! : 0,
                },
              };
            },
          } );
        }
      }
    };
    if ( scrollTable ) scrollTable.addEventListener( "scroll", handleScroll );

    return () =>
    {
      if ( scrollTable ) scrollTable.removeEventListener( "scroll", handleScroll );
    };
  }, [ items, data ] );

  const [ columnVisibilityModel, setColumnVisibilityModel ] =
    useState<GridColumnVisibilityModel>( {} );

  useEffect( () =>
  {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.REPORTS_ASSET_DETAILS
    );
    if ( savedModel )
    {
      setColumnVisibilityModel( JSON.parse( savedModel ) );
    }
  }, [] );

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) =>
  {
    setColumnVisibilityModel( newModel );
    localStorage.setItem(
      ColumnVisibilityFor.REPORTS_ASSET_DETAILS,
      JSON.stringify( newModel )
    );
  };

  const { itemLabel } = useLabels();

  return (
    <>
      <div className="asset-reports__right--block">
        <div className="asset-reports__right--filters row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={( e ) =>
              {
                setSearchData( e.target.value );
              }}
            />
          </div>
          <div className="col-2">
            <ItemGroupSelect
              onChange={( newValue ) =>
              {
                if ( newValue )
                {
                  setFilterData( {
                    ...filterData,
                    ItemGroupId: newValue.value,
                  } );
                } else
                {
                  setFilterData( {
                    ...filterData,
                    ItemGroupId: 0,
                  } );
                }
              }}
              value={filterData.ItemGroupId}
              onKeyDown={handleMUISelectEvent}
              label={` Group`}
            />
          </div>
          <div className="col-2">
            <ItemCategorySelect
              onChange={( newValue ) =>
              {
                if ( newValue )
                {
                  setFilterData( {
                    ...filterData,
                    ItemCategoryId: newValue.value,
                  } );
                } else
                {
                  setFilterData( {
                    ...filterData,
                    ItemCategoryId: 0,
                  } );
                }
              }}
              value={filterData.ItemCategoryId}
              label={`${ itemLabel } Category`}
              onKeyDown={handleMUISelectEvent}
            />
          </div>

          <div className="col-2">
            <UoMSelect
              onChange={( newValue ) =>
              {
                if ( newValue )
                {
                  setFilterData( {
                    ...filterData,
                    UoMId: newValue.value,
                  } );
                } else
                {
                  setFilterData( {
                    ...filterData,
                    UoMId: 0,
                  } );
                }
              }}
              value={filterData.UoMId}
              label="Unit of Measurement"
              onKeyDown={handleMUISelectEvent}
            />
          </div>
        </div>
        <div className="asset-reports__right--tableblock">
          {items.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>
        <div className="asset-reports__right--block--footer">
          <div>
            <Button mode="excel">Excel</Button>
            <Button mode="back" onClick={() => navigate( -1 )} />
          </div>
          <div className="overall-total-count">
            Total {itemLabel} : <b>{items.length}</b>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorWiseItemsList;
